import { NodeModel } from '@minoru/react-dnd-treeview';
import { EmployeeNodeModel } from '../../models/groupedEmployee.model';
import {
    InterruptionModel,
    InterruptionsListModel,
} from '../../models/interruptions/interruptionList.model';
import {
    WorkshiftSchedulingModel,
    WorkshiftsListModel,
} from '../../models/workshifts/workshif-scheduling/workshiftSchedulingList.model';
import { getChildNodes, getDatesBetweenDates } from '../../utils';

type Props = {
    grid: any;
    treeEmployees: NodeModel[];
    startDate: string;
    endDate: string;
    interruptionList: InterruptionsListModel;
    workshiftShedulingList: WorkshiftsListModel;
    openCostCenterModal: (
        initDate: string,
        lastDate: string,
        employee: EmployeeNodeModel[],
        parentNodeSelected: number[]
    ) => void;
    getInterruptionsList: (
        startDate: string,
        endDate: string,
        employeeID: string | number,
        interruptionList: InterruptionsListModel
    ) => InterruptionModel[];
    getWorkshiftScheduling: (
        date: string | number,
        employeeID: string | number,
        workshiftShedulingList: WorkshiftsListModel
    ) => WorkshiftSchedulingModel | undefined;
};

export const controllerCostCenterModal = ({
    grid,
    treeEmployees,
    startDate,
    endDate,
    interruptionList,
    workshiftShedulingList,
    openCostCenterModal,
    getInterruptionsList,
    getWorkshiftScheduling,
}: Props) => {
    let recoveredData = window.localStorage.getItem('selection-range');

    let row1 = grid.selectedRanges[0].row;
    let row2 = grid.selectedRanges[0].row2;
    let col1 = grid.selectedRanges[0].col - 2;
    let col2 = grid.selectedRanges[0].col2 - 2;

    if (row1 > row2) {
        let aux = row1;
        row1 = row2;
        row2 = aux;
    }

    if (col1 > col2) {
        let aux = col1;
        col1 = col2;
        col2 = aux;
    }

    let initDate = getDatesBetweenDates(startDate, endDate)[col1];
    let lastDate = getDatesBetweenDates(startDate, endDate)[col2];

    let selectedEmployees = getChildNodes(treeEmployees).slice(row1, row2 + 1);

    let dates = getDatesBetweenDates(initDate, lastDate);

    let workshiftIds: number[] = [];
    let workshiftsFloating: WorkshiftSchedulingModel[] | undefined = [];
    let interruptions: number[] = [];
    let parentNodeSelected: number[] = [];

    if (recoveredData) {
        let data: Array<{
            employeeId: string | number;
            text: string;
            date: string;
            parent: string;
        }> = JSON.parse(recoveredData);

        data.forEach((emp) => {
            let workshiftId = getWorkshiftScheduling(
                emp.date,
                emp.employeeId,
                workshiftShedulingList
            )?.id;

            if (workshiftId) {
                workshiftIds.push(workshiftId);
            }
        });

        data.forEach(({ date, employeeId }) => {
            let interruption = getInterruptionsList(
                date,
                date,
                employeeId,
                interruptionList
            );

            interruption.forEach((interr) => {
                interruptions.push(interr.id);
            });
        });

        data.forEach((emp) => {
            if (!parentNodeSelected.includes(Number(emp.parent))) {
                parentNodeSelected.push(Number(emp.parent));
            }
        });

        let employees: NodeModel[] = data.map((emp) => ({
            id: emp.employeeId,
            parent: '',
            text: emp.text,
            droppable: false,
        }));

        if (workshiftIds.length > 0 || interruptions.length > 0) {
            openCostCenterModal('', '', employees, parentNodeSelected);
        }
    } else {
        selectedEmployees.forEach((s) => {
            if (!parentNodeSelected.includes(Number(s.parent))) {
                parentNodeSelected.push(Number(s.parent));
            }
        });

        for (let emp = 0; emp < selectedEmployees.length; emp++) {
            for (let date = 0; date < dates.length; date++) {
                let workshiftId = getWorkshiftScheduling(
                    dates[date],
                    selectedEmployees[emp].id,
                    workshiftShedulingList
                );
                if (workshiftId?.workshift?.isFloating) {
                    workshiftsFloating.push(workshiftId);
                }
                if (workshiftId?.id) {
                    workshiftIds.push(workshiftId.id);
                }
            }
        }

        if (initDate && lastDate && selectedEmployees.length > 0) {
            openCostCenterModal(
                initDate,
                lastDate,
                selectedEmployees,
                parentNodeSelected
            );
        }
    }
};
